// A price-tier label is not a selling unit. Keep the registered unit order.
// Legacy products with no unit list retain their single base-unit sale path.
function cashierUnitOptions(product) {
  const units = (product.units || []).filter(unit => typeof unit.name === 'string' && unit.name.trim());
  return units.length ? units : [null];
}
module.exports = { cashierUnitOptions };
